<template>
	<div class="tooltip">
		<i ref="arrow" class="tooltip-arrow"></i>
		<h2 class="title">{{ title }}</h2>
		<div class="wysiwyg-content" v-html="info" />
	</div>
</template>

<script>
export default {
	name: 'Tooltip',
	props: {
		title: {
			type: String,
			required: true,
		},
		info: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.tooltip {
		position: absolute;
		top: 0;
		left: calc(100% + 5px);
		width: 225px;
		background: $off-white;
		text-align: left;
		padding: 10% 15% 10% 20%;

		@include mobile { width: 300px; }

		.tooltip-arrow {
			width: 0;
			height: 0;
			border-style: solid;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 100%;
			margin: auto 0;
			border-color: $off-white;
			border-width: 10px 10px 10px 0;
			border-left-color: transparent !important;
			border-top-color: transparent !important;
			border-bottom-color: transparent !important;
		}
	}

	.title {
		color: $background-color-dark;
		font-size: $font-size-base;

		@include mobile { font-size: $font-size-sm; }
	}

	.wysiwyg-content {
		color: $alt-color;
		font-size: $font-size-sm;
		text-transform: none;

		@include mobile { font-size: $font-size-x-sm; }
	}
</style>



// WEBPACK FOOTER //
// src/components/base/Tooltip.vue